import { render } from "./ProposalArgumentPlayerPlaylist.vue?vue&type=template&id=18246240&scoped=true"
import script from "./ProposalArgumentPlayerPlaylist.vue?vue&type=script&lang=js"
export * from "./ProposalArgumentPlayerPlaylist.vue?vue&type=script&lang=js"

import "./ProposalArgumentPlayerPlaylist.vue?vue&type=style&index=0&id=18246240&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18246240"]])

export default __exports__